/**
 * Moves an item of the array from startIndex to endIndex.
 * @param list the array to re-order - this does not mutate the original array
 * @param startIndex index of the element to move
 * @param endIndex destination index of the moved element
 * @returns a new array, re-ordered with the specified element at startIndex moved to endIndex
 */
const reorderArray = <T>(list: T[], startIndex: number, endIndex: number): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default reorderArray;
